<h6 class="reassignSubmissionHeader">
    <i class="fa fa-user mr-1" aria-hidden="true"></i>Reassign DOT: {{curWorkInProgress().dotNumber}}
</h6>
<p-card class="userBorder" header="">
    <form #f="ngForm" style="width:100%"
    (ngSubmit)="submit()">
        <div class="row col-md-12 mt-3 mb-3">
            <div class="col-md-4">
                <div class="col-md-12 ipad_28 userManagementClass">
                    <label name="CurrentAgentLabel" id="CurrentAgentLabelID">
                        Current Agent
                    </label>
                </div>
                <div class="col-md-12 ipad_65">
                    <input class="form-control" [value]="curWorkInProgress().agentName" type="text" 
                        name="CurrentAgent" id="CurrentAgentID" disabled>
                </div>
            </div>
                <div class="col-md-4">
                    <div class="col-md-12 ipad_28 userManagementClass">
                        <label name="ReassignToLabel" id="ReassignToLabelID">
                            Reassign To <span class="text-danger">*</span>
                        </label>
                    </div>
                    <div class="col-md-12 ipad_65">
                        <p-select placeholder="Reassign To"
                            [options]="otherAgents()" [filter]="true" filterBy="label,value"
                            [(ngModel)]="selectedAgent" 
                            name="ReassignTo" id="ReassignToID" #ReassignTo="ngModel" required
                            appendTo="body" [disabled]="f.submitted && agentListService.submissionReassigned()"
                            [class.validateDrodown]="f.submitted && !ReassignTo?.valid && !agentListService.submissionReassigned()">
                            <ng-template let-option pTemplate="item">
                                {{option.label}} - {{option.value}}
                            </ng-template>
                        </p-select>
                        <span class="text-danger" *ngIf="f.submitted && !ReassignTo?.valid && !agentListService.submissionReassigned()">
                            Please select an agent to reassign the submission.
                        </span>
                    </div>
                </div>
            <div class="col-md-4  text-right">
                <div class="col-md-12 ipad_28 userManagementClass text-right">
                    <label>&ensp; </label>
                </div>
                <div class="col-md-12 ipad_65">
                    <div class="btn-group-row">
                    <button class="btnsuccess" title="Reassign" name="reassignBtn" id="reassignBtn"
                        data-toggle="modal" type="submit" [disabled]="f.submitted && agentListService.submissionReassigned()">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Reassign
                    </button>
                    <button class="btnCancelSub" title="Cancel" name="cancel" id="cancelID"
                        data-toggle="modal" type="button" (click)="onCloseClicked()">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                        {{ f.submitted && agentListService.submissionReassigned() ? 'Close' : 'Cancel' }}
                    </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 display-success-message">
                {{ f.submitted ? displayResponseMessage() : '' }}
            </div>
        </div>
    </form>
</p-card>